// Class: haxe.xml._Access.HasNodeAccess_Impl_

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
var $hxEnums = require("./../../../hxEnums_stub").default;

// Constructor

var HasNodeAccess_Impl_ = function(){}

// Meta

HasNodeAccess_Impl_.__name__ = "haxe.xml._Access.HasNodeAccess_Impl_";
HasNodeAccess_Impl_.__isInterface__ = false;
HasNodeAccess_Impl_.prototype = {
	
};
HasNodeAccess_Impl_.prototype.__class__ = HasNodeAccess_Impl_.prototype.constructor = $hxClasses["haxe.xml._Access.HasNodeAccess_Impl_"] = HasNodeAccess_Impl_;

// Init



// Statics

HasNodeAccess_Impl_.resolve = function(this1,name) {
	return this1.elementsNamed(name).hasNext();
}


// Export

exports.default = HasNodeAccess_Impl_;